import React, { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router';

import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import ClassType, { classTypeToGenerated } from '../../model/pripomienka/ClassType';
import { useClient } from '../../context/ClientStatusContext';
import { removePripomienka } from '../../client/removePripomienkaClient';
import Secured from '../Secured';
import UserRole from '../../model/currentuser/UserRole';
import routes from '../../routing/routes';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';
import { canRemove } from '../../function/permissions';
import { useUserContext } from '../../context/UserContext';
import PripomienkaDetail from '../../model/pripomienka/PripomienkaDetail';
import { useHistoryContext } from '../../context/HistoryContext';

interface Props {
  classType: ClassType;
  pripomienkaDetail: PripomienkaDetail,
}

const RemovePripomienkaButton = (
  {
    classType, pripomienkaDetail,
  }: Props,
): ReactElement => {
  const {
    type, year, index, uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const { wrapClient, status } = useClient(removePripomienka);
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  const { pouzivatel, legislationProcess, fetchProfile } = useUserContext();
  const { lastVisitedListPage } = useHistoryContext();

  const handleRemove = async (): Promise<void> => {
    await wrapClient(
      classTypeToGenerated(classType),
      type,
      year,
      index,
      uuid,
    );
    fetchProfile(type, year, index);
    if (lastVisitedListPage) {
      navigate(lastVisitedListPage);
    }
    if (classType === ClassType.PRIPOMIENKA) {
      if (!lastVisitedListPage) {
        navigate(routes.pripomienky.list.withParams(type, year, index));
      }
      displaySuccess('Pripomienka bola úspešne odstránená.');
    } else {
      if (!lastVisitedListPage) {
        navigate(routes.hromadnePripomienky.list.withParams(type, year, index));
      }
      displaySuccess('Hromadná pripomienka bola úspešne odstránená.');
    }
  };
  return (
    <Secured
      allowForRoles={[UserRole.SUPERADMIN, UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.PRIPOMIENKOVATEL]}
      additionalCheck={canRemove(pouzivatel, legislationProcess, classType, pripomienkaDetail)}
    >
      <ConfirmModal
        question="Naozaj si želáte pripomienku odstrániť? Túto akciu nie je možné vrátiť späť."
        cancelButtonText="Nie"
        confirmButton={(<Button buttonStyle="action" size="large">Áno</Button>)}
        openButton={(
          <LoaderButton
            className="remove-pripomienka-button"
            buttonStyle="negative"
            loading={status.loading}
            size="large"
          >
            Odstrániť
          </LoaderButton>
        )}
        doAfterConfirm={handleRemove}
      />
    </Secured>
  );
};

export default RemovePripomienkaButton;
